module.exports = __webpack_public_path__ + "img/pt-26.bfb9709f.jpg";